import { render } from "./WCCouponCard.vue?vue&type=template&id=5cacc056&scoped=true"
import script from "./WCCouponCard.vue?vue&type=script&lang=js"
export * from "./WCCouponCard.vue?vue&type=script&lang=js"

import "./WCCouponCard.vue?vue&type=style&index=0&id=5cacc056&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cacc056"]])

export default __exports__